import { Button, TextField } from "@mui/material";

import { Box, Typography } from "@mui/material";

import { Modal } from "@mui/material";

import { Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ModalStyle } from "../Signups/CreationSelectionModal";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import recurringUTCConverter from "./recurringUTCConverter";
import DateTimeLoc from "./DateTimeLoc";
import LeagueRegistration, { LeagueInformation } from "./LeagueRegistration";
import DeleteIcon from "@mui/icons-material/Delete";

function RegisterTournamentModal({
  registerModal,
  setRegisterModal,
  devPort,
  clubId,
  eventToEdit,
  filterGames,
  setEventToEdit,
}: {
  registerModal: boolean;
  setRegisterModal: (value: boolean) => void;
  devPort: string;
  clubId: number;
  eventToEdit: any;
  filterGames: () => void;
  setEventToEdit: (value: any) => void;
}) {
  const [registerDate, setRegisterDate] = useState("");
  const [registerEndDate, setRegisterEndDate] = useState("");
  /*const [registerStartTime, setRegisterStartTime] = useState<Dayjs | null>(
    dayjs(moment().set({ hour: 0, minute: 0, second: 0 }))
  );*/
  const [registerStartTime, setRegisterStartTime] = useState(
    dayjs(moment().set({ hour: 0, minute: 0, second: 0 }))
  );
  const [registerField, setRegisterField] = useState("");
  const [registerModalLeagues, setRegisterModalLeagues] = useState(false);
  const [tournamentName, setTournamentName] = useState("");
  const [leaguesDetails, setLeaguesDetails] = useState<LeagueInformation[]>([]);
  const [editMode, setEditMode] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  useEffect(() => {
    if (eventToEdit && registerModal) {
      console.log("Tournament TO EDIT", eventToEdit);
      setRegisterDate(moment(eventToEdit.raw_date).format("YYYY-MM-DD")); //.format("YYYY-MM-DD"));
      setRegisterStartTime(dayjs(eventToEdit.raw_date));
      setRegisterEndDate(moment(eventToEdit.end_date).format("YYYY-MM-DD"));
      //setRegisterStartTime(gameToEdit.game_date);
      //dayjs('2022-04-17T15:30')
      setRegisterField(eventToEdit.field_location);
      setTournamentName(eventToEdit.tournament_name);
      setLeaguesDetails(eventToEdit.leagues);
      setEditMode(true);
      setRegisterModal(true);
    }
  }, [eventToEdit, registerModal, setRegisterModal]);
  function resetRecurringParams() {
    //setRecurringEvent(false);
    setRegisterDate("");
    setRegisterEndDate("");
    /*const utc_start_date = moment(moment().format("YYYY-MM-DD") + "T00:00")
      .utc()
      .format("YYYY-MM-DDTHH:mm");
    setStartDate(utc_start_date);*/
    setRegisterField("");
    setTournamentName("");
    setLeaguesDetails([]);
    setEditMode(false);
    setRegisterModalLeagues(false);
    setEventToEdit(null);
  }

  function validFirstPage() {
    if (
      !registerDate ||
      !registerEndDate ||
      !registerStartTime ||
      !moment(registerDate).isValid() ||
      !moment(registerEndDate).isValid() ||
      !moment(registerStartTime).isValid()
    ) {
      window.alert("Enter a date and time");
    } /*else if (!registerField) {
      window.alert("Enter a field name");
    }*/ else {
      return true;
    }
    return false;
  }
  function verifyFirstPageFields() {
    if (validFirstPage()) {
      setRegisterModal(false);
      setRegisterModalLeagues(true);
    }
  }

  function handleBackToMain() {
    setRegisterModalLeagues(false);
    setRegisterModal(true);
  }

  function deleteTournamentLeague(league_id: number) {
    console.log("Deleting Tournament League");
    const fetchDelete = devPort + "delete_tournament_league";
    fetch(fetchDelete, {
      mode: "cors",
      credentials: "include",
      method: "POST",
      body: JSON.stringify({ tournament_id: league_id }),
    });
  }

  function registerTournament() {
    if (validFirstPage()) {
      const [, utc_lesson_time] = recurringUTCConverter(
        registerDate,
        registerStartTime,
        []
      );
      const [, utc_end_datetime] = recurringUTCConverter(
        registerEndDate,
        registerStartTime,
        []
      );
      const tournament_data = {
        club_id: clubId,
        tournament_name: tournamentName,
        leagues: leaguesDetails,
        start_date: utc_lesson_time,
        end_date: utc_end_datetime,
        tournament_id: editMode ? eventToEdit.id : null,
      };
      console.log(tournament_data);
      if (leaguesDetails.length === 0) {
        window.alert("Please add at least one league");
        return;
      }
      fetch(devPort + (editMode ? "update_tournament" : "add_tournament"), {
        mode: "cors",
        credentials: "include",
        method: "POST",
        body: JSON.stringify(tournament_data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("Generated Tournament");
          console.log(data);
          setRegisterModalLeagues(false);
          resetRecurringParams();
          filterGames();
          /*filterGames();
          if (data && data["message"]) {
            setMessageContent(data["message"]);
            setAlertMessage(true);
          }*/
        });
    }
  }

  function deleteTournament() {
    console.log("Deleting Tournament");
    const fetchDelete = devPort + "delete_tournament_group";
    fetch(fetchDelete, {
      mode: "cors",
      credentials: "include",
      method: "POST",
      body: JSON.stringify({ tournament_id: eventToEdit.id }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Deleted Tournament");
        console.log(data);
      });
  }

  return (
    <Stack>
      <Modal
        open={deleteModal}
        onClose={() => {
          setDeleteModal(false);
        }}
        aria-labelledby="Delete Tournament"
        aria-describedby="Delete tournament"
      >
        <Box sx={ModalStyle}>
          <Stack spacing={2}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Delete Tournament
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Are you sure you want to delete this tournament?
            </Typography>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Button
                  variant="outlined"
                  color="error"
                  style={{ width: "100%" }}
                  onClick={() => {
                    setDeleteModal(false);
                    deleteTournament();
                    setRegisterModal(false);
                    resetRecurringParams();
                  }}
                >
                  Delete
                </Button>
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Button
                  variant="contained"
                  style={{ width: "100%" }}
                  color="primary"
                  onClick={() => {
                    setDeleteModal(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Modal>
      <Modal
        open={registerModal}
        onClose={() => {
          setRegisterModal(false);
        }}
        aria-labelledby="Tournament Registration"
        aria-describedby="Create new tournament"
        style={{ overflow: "scroll" }}
      >
        <Box sx={ModalStyle}>
          <Stack spacing={2}>
            <DateTimeLoc
              modalMode={"Create New Tournament"}
              registerDate={registerDate}
              setRegisterDate={setRegisterDate}
              registerEndDate={registerEndDate}
              setRegisterEndDate={setRegisterEndDate}
              registerStartTime={registerStartTime}
              setRegisterStartTime={setRegisterStartTime}
              registerField={registerField}
              setRegisterField={null}
              disbaleTime={true}
            />
            <TextField
              id="tournament-name"
              label="Tournament Name"
              //variant="filled"
              value={tournamentName}
              onChange={(event) => {
                setTournamentName(event.target.value);
              }}
            />
            {editMode && (
              <Button
                id="delete-tournament"
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setDeleteModal(true);
                }}
              >
                <DeleteIcon />
                Delete Tournament
              </Button>
            )}
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="primary"
                  onClick={verifyFirstPageFields} //registerLesson}
                >
                  <NavigateNextIcon />
                  Next
                </Button>
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setRegisterModal(false);
                    resetRecurringParams();
                  }}
                >
                  <CloseIcon />
                  Close
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={registerModalLeagues}
        onClose={() => {
          setRegisterModalLeagues(false);
        }}
        aria-labelledby="League Registration"
        aria-describedby="Add leagues to tournament"
        style={{ overflow: "scroll" }}
      >
        <Box sx={ModalStyle}>
          <Stack spacing={2}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Add Leagues to Tournament
            </Typography>
            <LeagueRegistration
              onReset={resetRecurringParams}
              leaguesDetails={leaguesDetails}
              setLeaguesDetails={setLeaguesDetails}
              displayHandicap={true}
              title="League"
              deleteTournamentLeague={editMode ? deleteTournamentLeague : null}
            />
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="primary"
                  onClick={registerTournament}
                >
                  <NavigateNextIcon />
                  {editMode ? "Update" : "Save"}
                </Button>
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="error"
                  onClick={handleBackToMain}
                >
                  <CloseIcon />
                  Back
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Modal>
    </Stack>
  );
}

export default RegisterTournamentModal;
